import React, { useEffect } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";
import * as pageName from "store/actions/pageAction";
import { getTree, setSamplePDF } from "store/actions/fileAction";
import { pendingStatuses } from "helpers/file";
import Translate from "helpers/Translate";

export const ActivityBar = () => {
  const dispatch = useDispatch();
  const selectedPage = useSelector(state => state.page.payload);
  const selectedClient = useSelector(state => state.client.selectedClient);
  const selectedSubordinate = useSelector(state => state.file.getSubordinate);

  useEffect(() => {
    dispatch(setSamplePDF(pageName.PAGE_ACTIVITY_TREE_VIEW));
  }, [dispatch]);

  return (
    <div className="activity-bar">
      <ReactTooltip />

      {/* File Explorer */}
      <div
        data-tip={Translate({ id: "file_explorer" })}
        className={classNames("ico-parent", "my-20", {
          selected:
            pageName.PAGE_ACTIVITY_TREE_VIEW === selectedPage || !selectedPage
        })}
      >
        <Link
          className={classNames("activity-icon", "my-20", {
            selected: pageName.PAGE_ACTIVITY_TREE_VIEW === selectedPage
          })}
          to="/"
          onClick={e => {
            e.preventDefault();
            dispatch({
              type: pageName.PAGE_ACTIVITY_TREE_VIEW,
              payload: pageName.PAGE_ACTIVITY_TREE_VIEW
            });
            dispatch(
              getTree({
                client: selectedClient,
                fileStatus: pendingStatuses,
                subordinateId: selectedSubordinate?.id || ""
              })
            );
            dispatch(setSamplePDF(pageName.PAGE_ACTIVITY_TREE_VIEW));
          }}
        >
          <i className="fas fa-file-pdf"></i>
        </Link>
      </div>

      {/* Client Info */}
      <div
        data-tip={Translate({ id: "switch_client" })}
        className={classNames("ico-parent", "my-20", {
          selected: pageName.PAGE_ACTIVITY_CLIENT_INFO === selectedPage
        })}
      >
        <Link
          className={classNames("activity-icon", "my-20", {
            selected: pageName.PAGE_ACTIVITY_CLIENT_INFO === selectedPage
          })}
          to="/"
          onClick={e => {
            e.preventDefault();
            dispatch({
              type: pageName.PAGE_ACTIVITY_CLIENT_INFO,
              payload: pageName.PAGE_ACTIVITY_CLIENT_INFO
            });
            dispatch(setSamplePDF(pageName.PAGE_ACTIVITY_CLIENT_INFO));
          }}
        >
          <i className="fas fa-user-shield"></i>
        </Link>
      </div>

      {/* Send Bulk Review */}
      <div
        data-tip={Translate({ id: "send_bulk_files_for_review" })}
        className={classNames("hide ico-parent", "my-20", {
          selected: pageName.PAGE_ACTIVITY_BULK_REVIEW === selectedPage
        })}
      >
        <Link
          className={classNames("activity-icon", "my-20", {
            selected: pageName.PAGE_ACTIVITY_BULK_REVIEW === selectedPage
          })}
          to="/"
          onClick={e => {
            e.preventDefault();
            dispatch({
              type: pageName.PAGE_ACTIVITY_BULK_REVIEW,
              payload: pageName.PAGE_ACTIVITY_BULK_REVIEW
            });
            dispatch(setSamplePDF(pageName.PAGE_ACTIVITY_BULK_REVIEW));
          }}
        >
          <i className="fas fa-paper-plane"></i>
        </Link>
      </div>

      {/* Accuracy Report */}
      <div
        data-tip={Translate({ id: "my_accuracy_report" })}
        className={classNames("ico-parent", "my-20", {
          selected: pageName.PAGE_ACTIVITY_ACCURACY === selectedPage
        })}
      >
        <Link
          className={classNames("activity-icon", "my-20", {
            selected: pageName.PAGE_ACTIVITY_ACCURACY === selectedPage
          })}
          to="/"
          onClick={e => {
            e.preventDefault();
            dispatch({
              type: pageName.PAGE_ACTIVITY_ACCURACY,
              payload: pageName.PAGE_ACTIVITY_ACCURACY
            });
            dispatch(setSamplePDF(pageName.PAGE_ACTIVITY_ACCURACY));
          }}
        >
          <i className="fas fa-chart-line"></i>
        </Link>
      </div>

      {/* END */}
    </div>
  );
};

export default ActivityBar;
